import { withAuthenticationRequired } from '@auth0/auth0-react';
import GatedFeature from '../components/atoms/GatedFeature';
import styles from './AnalyticsPage.module.css';

function AnalyticsPage() {
  return (
    <div>
      <div className="page-header">
        <h2>Analytics (Dummy Data)</h2>
      </div>

      <GatedFeature requiredTier="premium">
        <div className={styles.analyticsContainer}>
          <div className={styles.statCard}>
            <h4>Total Engagements</h4>
            <p className={styles.statValue}>1,287</p>
            <span className={styles.statChange}>+15% this month</span>
          </div>
          <div className={styles.statCard}>
            <h4>Most Popular Profile</h4>
            <p className={styles.statValue}>Professional Profile</p>
            <span className={styles.statChange}>450 engagements</span>
          </div>
          <div className={styles.statCard}>
            <h4>Top Conversation Starter</h4>
            <p className={styles.statValue}>"What's your biggest challenge?"</p>
            <span className={styles.statChange}>Asked 82 times</span>
          </div>
          <div className={`${styles.statCard} ${styles.fullWidth}`}>
            <h4>Engagement Over Time</h4>
            <div className={styles.chartPlaceholder}>
              <p>Chart coming soon</p>
            </div>
          </div>
        </div>
      </GatedFeature>
    </div>
  );
}

export default withAuthenticationRequired(AnalyticsPage);
